export default __webpack_public_path__ + "static/media/icon-menu.2969e51f.svg";